export class UserInfo {
    public firstName!: string;
    public lastName!: string;
    public email!: string;
    public phoneNumber!: string;
    public emailConfirmed!: boolean;
    public phoneNumberConfirmed!: boolean;
}
